// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"19f769f5","238":"07ec727d","239":"23797570","557":"176c25b6","732":"5e3324a8","762":"56bc38b9"}[chunkId] + ".chunk.js";
};